import zod from 'zod'

export const licenseExtensionSchema = zod.object({
  name: zod.string().min(3, 'Deve ter ao menos 3 letras').trim(),
  licensesAmount: zod
    .number({ errorMap: () => ({ message: 'Obrigatório' }) })
    .int('Deve ser um número inteiro')
    .min(1, 'Deve ser ao menos 1'),
  price: zod
    .number({ errorMap: () => ({ message: 'Obrigatório' }) })
    .min(0.01, 'Deve ser maior que zero')
    .transform((v) => Math.round(v * 100)),
  active: zod.boolean(),
})

export type LicenseExtensionFormData = zod.infer<typeof licenseExtensionSchema>
